module.exports = __webpack_public_path__ + "static/media/paginate-previous.dc548700.svg";